<template>
  <div class="footer">
    <span>© 2005－2021 小橙家教</span>
    <span style="margin-left: 10px;">蜀ICP备2020035072号</span>
  </div>
</template>

<script>
export default {
  name: 'SimpleFooter',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .footer {
    width: 100%;
    text-align: center;
    height: 40px;
    line-height: 40px;

    span {
      width: 344px;
      height: 14px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 32px;
      letter-spacing: 0px;
      color: #333333;
    }
  }
</style>
